import React, { useState } from "react";
import Footer from "../components/common/footer";
import { Helmet } from "react-helmet";
import HeaderTwo from "../components/common/headerTwo";
import Hero from "../components/faq/hero";
import MapGoogle from "../components/common/map";
import ContactTimeline from "../components/contact/contactTimeline";


const faqData = [
  {
    category: "Oczyszczanie działek i mulczowanie",
    items: [
      {
        question: "Na czym polega oczyszczanie działki mulczerem leśnym?",
        answer: "Mulczer leśny (np. nasz Bobcat T66) to maszyna, która jednocześnie ścina i miele zarośla, krzaki, samosiejki, a nawet całe drzewa. Pozostawia na powierzchni rozdrobnioną biomasę, co poprawia jakość gleby i eliminuje problem wywozu odpadów."
      },
      {
        question: "Co wybrać: mulczowanie czy karczowanie?",
        answer: "Wybór zależy od przeznaczenia terenu. Mulczowanie jest najszybsze i najtańsze, idealne do porządkowania zarośli. Jeśli jednak planujesz na działce fundamenty, drogę lub trawnik, konieczne będzie karczowanie, które usuwa rośliny wraz z systemem korzeniowym."
      },
      {
        question: "Jakie tereny jesteście w stanie oczyścić?",
        answer: "Oczyszczamy działki budowlane, rolne, inwestycyjne, leśne, a także tereny trudne: skarpy, rowy melioracyjne, pasy pod liniami wysokiego napięcia oraz tereny pod farmy wiatrowe."
      },
      {
        question: "Od czego zależy koszt oczyszczenia zarośniętej działki?",
        answer: "Cena zależy od powierzchni (wyceniamy za hektar lub m2), rodzaju i gęstości roślinności, ukształtowania terenu oraz konieczności użycia ciężkiego sprzętu. Zawsze oferujemy darmową wycenę na podstawie zdjęć lub oględzin."
      }
    ]
  },
  {
    category: "Wycinka drzew (klasyczna i alpinistyczna)",
    items: [
      {
        question: "Kiedy konieczna jest wycinka alpinistyczna?",
        answer: "Metodę alpinistyczną (arborystyczną) stosujemy tam, gdzie nie ma miejsca na powalenie całego drzewa. Ścinamy je po kawałku od góry. Jest to niezbędne w gęstej zabudowie, blisko ogrodzeń, dachów czy linii energetycznych."
      },
      {
        question: "Czy samodzielna wycinka drzewa jest bezpieczna?",
        answer: "Bez odpowiedniego sprzętu i doświadczenia jest to bardzo niebezpieczne. Niekontrolowane obalenie pnia może zniszczyć mienie lub zagrozić zdrowiu. Nasi fachowcy potrafią precyzyjnie ocenić środek ciężkości i bezpiecznie położyć każde drzewo."
      },
      {
        question: "Czy uprzątacie teren po wycince?",
        answer: "Tak, działamy kompleksowo. Ścinamy drzewo, możemy zrębkować gałęzie, usunąć pień (frezując go lub karczując z korzeniami) i wywieźć wszystkie pozostałości z Twojej działki."
      }
    ]
  },
  {
    category: "Usuwanie pni: Frezowanie vs. Karczowanie",
    items: [
      {
        question: "Czym różni się frezowanie od karczowania pni?",
        answer: "Frezowanie to mechaniczne starcie pnia do ok. 38 cm poniżej gruntu – jest szybkie, nie niszczy trawnika i nie wymaga wjazdu koparki. Karczowanie to całkowite wykopanie pnia wraz z korzeniami, niezbędne, gdy w tym miejscu planujesz fundamenty lub głębokie wykopy."
      },
      {
        question: "Co zrobić z ubytkiem ziemi po wykopaniu (wykarczowaniu) pnia?",
        answer: "Nasz sprzęt (koparki, miniładowarki) otrząsa ziemię z wyrwanych korzeni, która wraca do wykopu. Ewentualne braki uzupełniamy ziemią w ramach prac niwelacyjnych."
      }
    ]
  },
  {
    category: "Formalności i inwentaryzacja zieleni",
    items: [
      {
        question: "Czy pomagacie w uzyskaniu pozwolenia na wycinkę?",
        answer: "Tak! Przejmujemy na siebie całą 'papierologię'. Mamy w zespole dendrologa i ornitologa. Wypełniamy wnioski, sprawdzamy obwody pni i składamy dokumenty w urzędzie gminy lub miasta."
      },
      {
        question: "Co to jest inwentaryzacja dendrologiczna?",
        answer: "To dokładny spis drzew i krzewów na działce (gatunek, wysokość, obwód pnia, stan zdrowia), niezbędny m.in. do uzyskania decyzji środowiskowej przed rozpoczęciem większej inwestycji budowlanej."
      },
      {
        question: "Czy muszę mieć pozwolenie na wycięcie każdego drzewa?",
        answer: "Nie, zależy to od obwodu pnia mierzonego na wysokości 5 cm od gruntu (limity różnią się w zależności od gatunku). Nasz zespół oceni to na miejscu i wskaże, które drzewa wymagają zgłoszenia."
      }
    ]
  },
  {
    category: "Prace ziemne i niwelacja terenu",
    items: [
      {
        question: "Na czym polega niwelacja terenu?",
        answer: "Niwelacja to wyrównanie ukształtowania działki – zbieramy nadmiar ziemi z górek i zasypujemy zagłębienia. Jest niezbędna przed założeniem trawnika, budową domu, tarasu czy rozłożeniem basenu."
      },
      {
        question: "Jakie wykopy robicie w ramach prac ziemnych?",
        answer: "Kopiemy pod fundamenty, szamba, instalacje wod-kan i gazowe, kable energetyczne, a także korytujemy teren pod kostkę brukową i drogi dojazdowe."
      },
      {
        question: "Dlaczego używacie glebogryzarki?",
        answer: "Nasza glebogryzarka ciągnikowa (np. John Deere) mechanicznie spulchnia ziemię na głębokość do 20 cm, usuwa chwasty, miesza glebę i napowietrza ją. To najlepszy sposób na przygotowanie trudnej, zbitej ziemi pod idealny trawnik."
      }
    ]
  },
  {
    category: "Trawniki, ogrody i nawadnianie",
    items: [
      {
        question: "Trawnik z rolki czy z siewu – co jest lepsze?",
        answer: "Trawnik z rolki zapewnia natychmiastowy, zachwycający efekt od razu po ułożeniu. Trawnik z siewu jest rozwiązaniem bardziej budżetowym, ale wymaga około miesiąca, by wzejść, i potrzebuje więcej uwagi w początkowej fazie wzrostu."
      },
      {
        question: "Czy zabezpieczacie trawnik przed kretami?",
        answer: "Tak, na życzenie klienta przed rozsypaniem warstwy urodzajnej ziemi rozkładamy specjalną siatkę na odpowiedniej głębokości, która trwale powstrzymuje krety przed niszczeniem murawy."
      },
      {
        question: "Na jakich podzespołach bazują Wasze systemy nawadniania?",
        answer: "Korzystamy ze sprzętu czołowych, sprawdzonych producentów takich jak Hunter, Gardena i Rain Bird. Zapewnia to wieloletnią bezawaryjność i łatwy dostęp do ewentualnych części zamiennych."
      },
      {
        question: "Czy system nawadniania można założyć w już istniejącym ogrodzie?",
        answer: "Najlepiej robić to przed założeniem trawnika, ale tak – podejmujemy się montażu instalacji (rur, zraszaczy, linii kroplujących) również w wieloletnich ogrodach, robiąc to w sposób jak najmniej inwazyjny dla roślin."
      }
    ]
  }
];


function FaqList() {

  const [openId, setOpenId] = useState<string | null>(null);

  const toggleFAQ = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="p-6 lg:px-24 lg:py-16 flex flex-col lg:flex-row items-start justify-between gap-10 lg:gap-16">
      
     
      <div className="w-full lg:w-2/3 flex flex-col gap-10">
        {faqData.map((categoryGroup, catIndex) => (
          <div key={catIndex} className="flex flex-col gap-4">
            <h3 className="text-2xl font-bold color-green border-b-2 border-gray-100 pb-2">
              {categoryGroup.category}
            </h3>
            
            <div className="flex flex-col gap-3">
              {categoryGroup.items.map((item, itemIndex) => {
                const itemId = `${catIndex}-${itemIndex}`;
                const isOpen = openId === itemId;

                return (
                  <div
                    key={itemIndex}
                    className="rounded-xl p-5 flex flex-col bg-gray-50 border border-gray-100 text-left gap-2 cursor-pointer hover:bg-gray-100 transition-all duration-200"
                    onClick={() => toggleFAQ(itemId)}
                  >
                    <div className="flex flex-row items-center justify-between gap-4">
                      <p className="font-semibold text-gray-800 text-lg">
                        {item.question}
                      </p>
                      <div className="shrink-0 rounded-full bg-green text-white text-center w-8 h-8 text-lg font-semibold flex items-center justify-center">
                        {isOpen ? "-" : "+"}
                      </div>
                    </div>
                    
                    <p
                      className={`text-gray-600 mt-2 transition-all duration-300 ${
                        isOpen ? "block" : "hidden"
                      }`}
                    >
                      {item.answer}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>


      <div className="w-full lg:w-1/3 sticky top-32 flex flex-col items-start justify-start gap-2">
        <h2 className="uppercase color-yellow text-xl font-semibold">Baza Pytań</h2>
        <h3 className="text-4xl lg:text-5xl color-green text-left font-bold">
          Masz <span className="color-yellow">wątpliwości?</span>
        </h3>
        <p className="text-gray-600 mt-2 text-lg">
          Zawarliśmy tu najważniejsze informacje o wycince, mulczowaniu i ogrodach. Jeśli Twojego pytania nie ma na liście, napisz do nas!
        </p>
        
        <div className="flex flex-col items-start justify-start gap-1 bg-yellow p-6 rounded-xl w-full mt-6 shadow-lg">
          <p className="text-2xl font-semibold text-white font-head">
            Indywidualny projekt?
          </p>
          <p className="text-white text-lg opacity-90 mb-4">Darmowa wycena i doradztwo.</p>
          <a href="/kontakt" className="w-full">
            <button className="button-green w-full py-3 text-lg">
              Skontaktuj się z nami
            </button>
          </a>
        </div>
      </div>

    </section>
  );
}


function Faq() {
  return (
    <>
      <Helmet>
        <title>FAQ - Często zadawane pytania | Drzewus</title>
        <meta name="title" content="FAQ - Pytania i odpowiedzi | Drzewus" />
        <meta
          name="description"
          content="Masz pytania dotyczące naszych usług ogrodniczych, wycinki drzew, projektowania lub nawadniania? Sprawdź listę najczęściej zadawanych pytań."
          key="desc"
        />
        <meta property="og:title" content="FAQ - Często zadawane pytania | Drzewus" />
        <meta
          property="og:description"
          content="Masz pytania dotyczące naszych usług ogrodniczych, wycinki drzew, projektowania lub nawadniania? Sprawdź listę najczęściej zadawanych pytań."
        />
        <meta
          property="og:image"
          content="https://yourdomain.com/path/to/og-image.png"
        />
      </Helmet>
      
      <HeaderTwo />
      
      <main className="relative z-40">
        <Hero />
        
   
        <FaqList />
        
      </main>
      
      <Footer />
    </>
  );
}

export default Faq;